import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { socket } from 'api';
import { user } from 'services/user';
import { Wrapper, Content } from './options.styled';
import { OptionReceipt } from './option-receipt/option-receipt';

export const OptionsCashbox = ({ id }) => {
  const status = useSelector((store) => store.equipment[id] ?? {});
  const { mode } = status;
  const offline = mode === 'offline';
  const withReceipt = user.haveRight('receipt_template.edit');

  /**
   * send socket msg
   * @param {*} message
   * @param {*} params
   */
  const sendControlMsg = (message, params) => {
    const data = Object.assign({ target: id, user_id: user.getId() }, params);
    socket.call(message, data);
  };

  // update state
  useEffect(() => {
    sendControlMsg('get_state');
  }, []);

  let cl2 = offline || !mode ? 'offline1' : '';

  return (
    <Wrapper>
      <Content className={cl2}>
        {withReceipt && <OptionReceipt sendControlMsg={sendControlMsg} templateId={status?.printer?.receipt_template_id} />}
      </Content>
    </Wrapper>
  );
};
